import { useSelector } from "react-redux";
import { getStatusForGlobalFetchPartition } from "./selectors";
import { GlobalFetchPartition } from "./reducer";

// eslint-disable-next-line import/prefer-default-export
export const useStatusForGlobalFetchPartition = (
  partition: GlobalFetchPartition
) => useSelector((s) => getStatusForGlobalFetchPartition(s, partition));
